import mixitup from 'mixitup';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useBlogs } from '../../../common/BlogContext';

function FilterPosts() {
  const { blogs } = useBlogs();
  const [activeFilter, setActiveFilter] = useState('All');
  const [isEmpty, setIsEmpty] = useState(false);
  const mixitupContainerRef = useRef(null);
  const mixerRef = useRef(null);

  const defaultTags = ['All', 'Architecture', 'Guide', 'Inspiration'];
  const dynamicTags = [
    ...new Set(
      blogs.flatMap((b) =>
        b.category ? b.category.split(/[,\s]+/).filter(Boolean) : []
      )
    ),
  ];
  const allTags = [
    ...defaultTags,
    ...dynamicTags.filter((t) => !defaultTags.map(d => d.toLowerCase()).includes(t.toLowerCase())),
  ];

  useEffect(() => {
    if (!mixitupContainerRef.current || blogs.length === 0) return;
    if (mixerRef.current) {
      try { mixerRef.current.destroy(); } catch (_) {}
      mixerRef.current = null;
    }
    mixerRef.current = mixitup(mixitupContainerRef.current, {
      load: { sort: 'order:asc' },
      animation: { duration: 500 },
      selectors: { target: '.mix-item' },
      callbacks: {
        onMixEnd: (state) => {
          setIsEmpty(state.totalShow === 0);
        },
      },
    });
    return () => {
      if (mixerRef.current) {
        try { mixerRef.current.destroy(); } catch (_) {}
        mixerRef.current = null;
      }
    };
  }, [blogs]);

  const handleFilterClick = (tag) => {
    setActiveFilter(tag);
    if (!mixerRef.current) return;
    const selector = tag === 'All' ? 'all' : `.${tag.toLowerCase()}`;
    try {
      mixerRef.current.filter(selector);
    } catch (_) {}
  };

  return (
    <section className="tc-filter-posts-style1">
      <div className="container">
        <div className="filter-row wow fadeInUp slow" data-wow-delay="0.2s">
          <div className="row align-items-center">
            <div className="col-lg-9">
              <div className="filter">
                <div className="links">
                  {allTags.map((tag) => (
                    
                     <a key={tag}
                      href="#0"
                      onClick={(e) => { e.preventDefault(); handleFilterClick(tag); }}
                      className={`filter-btn ${activeFilter === tag ? 'active' : ''}`}
                    >
                      {tag}
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-lg-3 mt-5 mt-lg-0">
              <div className="search-group">
                <input type="text" className="form-control" placeholder="Search in blog" />
                <button><i className="fal fa-search"></i></button>
              </div>
            </div>
          </div>
        </div>

        <div className="posts-content">
          {blogs.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 0', color: '#999' }}>
              <p>No articles yet.</p>
              <Link to="/admin" style={{ color: '#4f46e5', fontWeight: 600, textDecoration: 'none' }}>
                Add your first article in Admin →
              </Link>
            </div>
          ) : (
            <>
              {isEmpty && (
                <div style={{ textAlign: 'center', padding: '60px 0', color: '#999' }}>
                  <i className="ti ti-article-off" style={{ fontSize: 40, display: 'block', marginBottom: 12 }}></i>
                  <p>No articles found under <strong>{activeFilter}</strong> category yet.</p>
                </div>
              )}
              <div className="row" ref={mixitupContainerRef}>
                {blogs.map((item, i) => {
                  const classes = item.category
                    ? item.category.split(/[,\s]+/).filter(Boolean).map(t => t.toLowerCase()).join(' ')
                    : '';
                  const tags = item.category
                    ? item.category.split(/[,\s]+/).filter(Boolean)
                    : [];
                  return (
                    <div key={item.id ?? i} className={`col-lg-4 mix-item ${classes}`}>
                      <div className="post-card mt-70 wow fadeInUp slow" data-wow-delay="0.2s">
                        <Link
                          to={`/blog/${item.id}`}
                          className="img th-280 radius-7 overflow-hidden d-block"
                        >
                          {item.img ? (
                            <img src={item.img} alt={item.title} className="img-cover" />
                          ) : (
                            <div
                              className="img-cover"
                              style={{
                                background: '#f0f0ff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%',
                                color: '#c4b5fd',
                                fontSize: 40,
                              }}
                            >
                              <i className="ti ti-photo" aria-hidden="true"></i>
                            </div>
                          )}
                        </Link>
                        <div className="info pt-30">
                          <div className="tags color-666 text-uppercase fsz-12">
                            <a href="#" className="color-orange1">
                              {tags.join(', ')}
                            </a>
                            {item.publish_date && (
                              <>
                                <span className="circle icon-3 bg-666 rounded-circle mx-3"></span>
                                <a href="#"> {item.publish_date} </a>
                              </>
                            )}
                          </div>
                          <h3 className="title mt-15">
                            <Link to={`/blog/${item.id}`} className="hover-orange1 fsz-24">
                              {item.title}
                            </Link>
                          </h3>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>

        {blogs.length > 6 && (
          <div className="text-center wow fadeInUp slow" data-wow-delay="0.2s">
            <a href="#" className="butn border rounded-pill color-orange1 border-orange1 hover-bg-orange1 mt-100 px-5">
              <span> Load More </span>
            </a>
          </div>
        )}
      </div>
    </section>
  );
}

export default FilterPosts;